import React, { useEffect, useState } from "react";
import InputField, { FileInputField } from "../../utils/tournament_creater";
import { FaFileImage } from "react-icons/fa";
import { useSelector } from "react-redux";

const CreateRosterPlayerForm = ({ closeModal, rosterId }) => {
  const { user } = useSelector((state) => state.user);
  const [playerData, setFormData] = useState({
    first_name: "",
    last_name: "",
    height: "",
    player_photo: "",
    age: "",
    city: "",
    identification: "",
    rol: "",
    phone_number: "",
    mail: "",
  });

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      roster_id: rosterId,
    }));
  }, [rosterId]);

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("roster_id", rosterId);
    formData.append("first_name", playerData.first_name);
    formData.append("last_name", playerData.last_name);
    formData.append("height", playerData.height);
    formData.append("player_photo", playerData.player_photo);
    formData.append("city", playerData.city);
    formData.append("age", playerData.age);
    formData.append("identification", playerData.identification);
    formData.append("rol", playerData.rol);
    formData.append("phone_number", playerData.phone_number);
    formData.append("mail", playerData.mail);

    console.log("Datos del jugador:", Object.fromEntries(formData));
    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/create-player",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Error al crear el jugador");
      }

      const data = await response.json();
      console.log(data); // Manejar la respuesta del servidor si es necesario
    } catch (error) {
      console.error("Error al crear el jugador:", error);
      // Manejo de errores...
    }
    closeModal();
  };

  return (
    <div
      className="max-w-md my-24 mx-auto  p-6 bg-white rounded shadow-md"
      style={{ width: "500px" }}
    >
      <div style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <h2 className="text-lg font-semibold mb-6">Crear Jugador</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <InputField
            placeholder="Nombre"
            id="first_name"
            name="first_name"
            type="text"
            value={playerData.first_name}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Apellido"
            id="last_name"
            name="last_name"
            type="text"
            value={playerData.last_name}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Altura (en cm)"
            id="height"
            name="height"
            type="text"
            value={playerData.height}
            onChange={handleChange}
            required
          />
          <FileInputField
            label="Foto jugador"
            id="player_photo"
            name="player_photo"
            accept="image/*"
            onChange={handleChange}
            required
            icon={FaFileImage}
            iconColor="blue-500"
          />
          <InputField
            placeholder="Edad"
            id="age"
            name="age"
            type="text"
            value={playerData.age}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Ciudad"
            id="city"
            name="city"
            type="text"
            value={playerData.city}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Identificación"
            id="identification"
            name="identification"
            type="text"
            value={playerData.identification}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Posición"
            id="rol"
            name="rol"
            type="text"
            value={playerData.rol}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Teléfono"
            id="phone_number"
            name="phone_number"
            type="text"
            value={playerData.phone_number}
            onChange={handleChange}
            required
          />
          <InputField
            placeholder="Email"
            id="mail"
            name="mail"
            type="text"
            value={playerData.mail}
            onChange={handleChange}
            required
          />
          <div className="flex justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Crear Jugador
            </button>
            <button
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={closeModal}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateRosterPlayerForm;
